import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const createOvertimeRule = async (data) => {
  const res = await axiosInstance.post("/api/payroll-portal/overtime-rule", data);
  return res.data;
};

export const getAllOvertimeRules = async () => {
  const res = await axiosInstance.get("/api/payroll-portal/overtime-rule");
  return res.data;
};

export const updateOvertimeRule = async (id, data) => {
  const res = await axiosInstance.put(`/api/payroll-portal/overtime-rule/${id}`, data);
  return res.data;
};
